import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  buttons: {
    '& #reject-button': {
      width: 87,
    },
    '& #accept-button': {
      width: 107,
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      paddingBottom: 0,
      '& #reject-button': {
        fontSize: 16,
        width: '50%',
      },
      '& #accept-button': {
        fontSize: 16,
        width: '50%',
      },
    },
  },
}));
